/* eslint-disable import/prefer-default-export */
import axios from 'axios'

/**
 * 取得推薦新聞
 * @param {String} ticker
 * @param {String} tagId
 * @param {Number} page
 * @return {Promise} axios promise
 */
export function requestNewsFilteredTrending({ ticker, tagId, page }) {
  return axios.get('/api/v1/news/filtered_trending', {
    params: {
      ticker,
      tag_id: tagId,
      page,
    },
  })
}
